import '../assets/scss/base.scss';
import React from "react"
import Header from "./header"
import Metadata from './sitemetadata';

export default ({children}) => (
  <React.Fragment>
    <Metadata />
    <noscript>Some page features may require javascript to run.</noscript>
    <div id="skipnav">
      <a href="#MainContent">Skip to Content (Press Enter)</a>
    </div>
    <Header />
    <main id="MainContent">
      {children}
    </main>
  </React.Fragment>
)